import { render, staticRenderFns } from "./account-1.vue?vue&type=template&id=0b02c525&"
import script from "./account-1.vue?vue&type=script&lang=ts&"
export * from "./account-1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports